import { render } from "./failed.vue?vue&type=template&id=29a752d2&scoped=true"
import script from "./failed.vue?vue&type=script&lang=js"
export * from "./failed.vue?vue&type=script&lang=js"

import "./failed.vue?vue&type=style&index=0&id=29a752d2&scoped=true&lang=css"

import exportComponent from "E:\\余思霖\\元数创梦\\School\\Clients\\student\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a752d2"]])

export default __exports__